<div class="header-primary">
  <div class="logo">
    <a #logo (click)="home()">
      <z-logo></z-logo>
    </a>
  </div>
  <div class="navigation">
    <p-menubar [model]="items$ | async"></p-menubar>
  </div>
</div>

<p-contextMenu
  #contextMenu
  *ngIf="!environmentService.environment.production"
  [model]="developerService.contextMenuItems$ | async"
  [target]="logo"
  appendTo="body"
></p-contextMenu>
